// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"603":"17342528","840":"e48084ae"}[chunkId] + ".chunk.css";
};